export default "__VITE_ASSET__B0HypzO0__"